import React from 'react';
import { HiX } from 'react-icons/hi';
import { getTagColor } from '../../../utils/tagColors';
import styles from './TagPill.module.css';

export interface TagPillProps {
  tag: string;
  onRemove?: () => void;
  showRemove?: boolean;
  size?: 'small' | 'medium';
  onClick?: () => void;
  className?: string;
}

const TagPill: React.FC<TagPillProps> = ({
  tag,
  onRemove,
  showRemove = false,
  size = 'small',
  onClick,
  className = '',
}) => {
  const color = getTagColor(tag);

  const handleRemoveClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onRemove?.();
  };

  return (
    <span
      className={`${styles.pill} ${styles[size]} ${onClick ? styles.clickable : ''} ${className}`}
      style={{ backgroundColor: color.bg, color: color.text }}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <span className={styles.text}>{tag}</span>
      {showRemove && onRemove && (
        <button
          type="button"
          className={styles.removeButton}
          onClick={handleRemoveClick}
          aria-label={`Remove ${tag}`}
          style={{ color: color.text }}
        >
          {/* @ts-ignore - react-icons compatibility with React 19 */}
          <HiX size={12} />
        </button>
      )}
    </span>
  );
};

export default TagPill;
